import { useEffect, useState } from "react";
import { useRouteMatch } from "react-router-dom";
import {
    SystemManagedDataCollection,
    SystemManagedDataEntity,
} from "@lifeat/shared/data-models/system/SystemManagedDataEntity";
import { SpaceCategory } from "@lifeat/shared/data-models/virtual-space/SpaceCategory";
import { Routes } from "@lifeat/shared/system/RouteConstants";
import { useDatabaseContext } from "@contexts/DatabaseContext";
import { buildRoute } from "@util/RouteUtil";
import { AdminError } from "../../features/admin/AdminError";
import { AdminSpaceCategoryControls } from "../../features/admin/AdminSpaceCategoryControls";
import LoadingView from "../../features/virtual-space/components/SpaceView/LoadingView/LoadingView";

type State =
    | {
          type: "loading";
      }
    | {
          type: "loaded";
          category: SpaceCategory;
          spaces: NonNullable<SystemManagedDataEntity["spaces"]>;
      }
    | {
          type: "error";
          message: string;
      };

export function AdminSpaceCategoryPage() {
    const [state, setState] = useState<State>({ type: "loading" });
    const match = useRouteMatch<Record<"category", string>>(buildRoute(Routes.AdminSpace, ":category"));
    const db = useDatabaseContext();

    useEffect(() => {
        setState({ type: "loading" });

        db.get(SystemManagedDataCollection.at("spaces").node)
            .then((res) => {
                if (res == null) {
                    setState({
                        type: "error",
                        message: "Missing spaces data",
                    });
                } else {
                    setState({
                        type: "loaded",
                        category: match.params.category as SpaceCategory,
                        spaces: res,
                    });
                }
            })
            .catch((e) => setState({ type: "error", message: String(e) }));
    }, [match.params.category, db]);

    if (state.type === "loading") {
        return <LoadingView isAppLoading />;
    }
    if (state.type === "error") {
        return <AdminError message={state.message} />;
    }
    return <AdminSpaceCategoryControls category={state.category} spaces={state.spaces} />;
}
